/**
 * Telemetry shim for the generation wizard.
 *
 * The wizard fires `track(EVENTS.X, {...})` at key moments (upload / preview / generate / download /
 * error). The shared analytics module (`src/analytics`) is being built in parallel by another agent.
 * To keep this feature's build green REGARDLESS of whether the `../../analytics` barrel yet exports a
 * `track`, this shim re-exports the canonical `EVENTS` constants (which already exist) and a `track`
 * that delegates to the Mixpanel sink, swallowing any error so analytics can never break a user flow.
 *
 * This re-exports the canonical analytics surface (`src/analytics`) so the wizard goes through the SAME
 * sink as the rest of the app, while guaranteeing analytics can never throw into a user flow. The
 * barrel's `track` is already a no-op until VITE_MIXPANEL_TOKEN is set.
 */
import { EVENTS, track as analyticsTrack } from "../../analytics";

export { EVENTS };

export function track(event: string, props?: Record<string, unknown>): void {
  try {
    analyticsTrack(event, props);
  } catch {
    // Analytics must never throw into a user flow.
  }
}
